<template>
    <div class="mt-50">
    <div class="container">
        <div class="columns">    
            <div class="column is-one-quarter">    
                <section>
                    <h1 class="title is-3">Recipes</h1>
                    <hr> 
                    <b-field>
                        <b-input placeholder="Search..."                    
                            style="border: 1px solid transparent;"
                            type="search"
                            v-model="filterText">
                        </b-input>
                    </b-field>
                    <ul class="menu-list">   
                            
                        <li v-for="(recipe, index) in filteredRecipes" :key="recipe.id" @click="addToMeal(index)">    
                            <a class="is-size-4">{{recipe.name}} <span v-if="user_id == recipe.user_id">YOURS</span></a>    
                            <hr style="margin:0px;"> 
                        </li>    
                    </ul>  
                </section>    
            </div>    


            <div class="column is-three-quarters">  
                <div class="columns">    
                <div class="column">
                <b-field class="image-uploader has-text-centered">
                <b-upload v-model="file" @input="onFileSelect"
                    multiple
                    accept="image/png,image/jpeg"
                    drag-drop>
                    <section class="section">
                        <div class="content has-text-centered">
                            <div v-if="mealData.mainImage">
                                <figure class="center-avatar" :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + mealData.mainImage + '?alt=media)' }">
                                </figure>
                            </div>
                            <div v-else>
                                <b-icon
                                    icon="upload"
                                    size="is-large">
                                </b-icon>
                                <p>Drop your files here or click to upload</p>
                            </div>
                        </div>
                    </section>
                </b-upload>
            </b-field>
            <div class="tags">
                <span
                    class="tag is-primary" v-if="file">
                    {{file[0].name}}
                    <button class="delete is-small"
                        type="button"
                        @click="deleteDropFile">
                    </button>
                </span>
            </div>
                    <section>                    
                        <b-input v-model="mealData.name" size="is-size-3" placeholder="Title" class="meal-title-input"></b-input>   
                    </section>    
                    <section>                    
                                        <b-input 
                                        maxlength="300" 
                                        v-model="mealData.subtitle" 
                                        type="textarea"
                                        placeholder="Subtitle (make it short!)" 
                                        class="meal-subtitle-input"></b-input>
                    </section>
                    <section>    
                        <nav class="level">    
                            <div class="level-item has-text-centered">    
                                <div>    
                                    <p class="heading">Prep Time</p>    
                                    <p class="title"><span v-if="mealData.prepTime.hours > 0">{{mealData.prepTime.hours}} hr, </span>    
                                        <span v-if="mealData.prepTime.minutes > 0">{{mealData.prepTime.minutes}} min</span></p>    
                                </div>    
                            </div>    
                            <div class="level-item has-text-centered">    
                                <div>    
                                    <p class="heading">Cook Time</p>    
                                    <p class="title"><span v-if="mealData.cookTime.hours > 0">{{mealData.cookTime.hours}} hr, </span>    
                                        <span v-if="mealData.cookTime.minutes > 0">{{mealData.cookTime.minutes}} min</span></p>    
                                </div>    
                            </div>    
                            <!--
                            <div class="level-item has-text-centered">    
                                <div>    
                                    <p class="heading">Servings</p>    
                                    <p class="title">{{mealData.servings}}</p>    
                                </div>    
                            </div>  
                            -->  
                        </nav>    
                    </section> 
                    <section>
                        <p class="content is-size-5 mb-20 mt-20">
                        Meal Type       
                        <b-field class="recipe-types">
                            <b-radio-button v-model="mealData.mealType"
                                v-for="mealType in mealType" :key="mealType"
                                :native-value="mealType"
                                type="is-dark">
                                <span>{{mealType}}</span>
                            </b-radio-button>
                        </b-field>
                        </p>
                    </section> 

                    <section>
                    <article  v-for="(mealSegment, index) in mealData.recipes" class="media"
                        :key="mealSegment.id">
                        <figure class="media-left has-text-centered">
                            <a>
                                <b-icon pack="fas" icon="arrow-up" @click.native="moveUp(index)"></b-icon>
                            </a>
                            <p>
                                <img class="dish-segment-img" :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+mealSegment.mainImage[0]+'?alt=media'">
                            </p>
                            <div>
                                <a>
                                    <b-icon pack="fas" icon="arrow-down" @click.native="moveDown(index)"></b-icon>
                                </a>
                            </div>

                        </figure>
                        <div class="media-content">
                        <div class="content" >
                            <div class="meal-title">
                                {{mealSegment.name}}
                                <a class="is-pulled-right">
                                    <b-icon pack="fas" icon="trash" @click.native="removeFromMeal(index)">    
                                    </b-icon>
                                </a>
                            </div>
                            <p>
                            {{mealSegment.subtitle}}
                            </p>
                        <!--
                            <b-collapse :open="false" position="is-bottom" aria-id="contentIdForA11y1">
                                <a slot="trigger" slot-scope="props" aria-controls="contentIdForA11y1">
                                    
                                        {{ !props.open ? 'See More' : 'Hide' }}
                                </a>
                                <p>
                                    {{mealSegment}}
                                </p>
                            </b-collapse>
                        -->
                            </div>
                        </div>
                        <hr style="margin:0px;"> 
                    </article >
                    </section>
                    
                                    
                    <section class="section">    
                        <div class="buttons">    
                            <span class="button is-success" @click="saveMeal">Save changes</span>    
                        </div>    
                    </section>    
                </div>    
                </div>    
                </div> 
            </div>   
        </div>  
    </div>
</template>
<script>
import firebase from '@/firebase';
import db from '@/db';
var uuidv4 = require('uuid/v4');

export default {
    data() {
        return {
            id: this.$route.params.id,
            isOpen: 0,
            recipes: [],
            recipeIds: [],
            user_id: null,
            filterText: null,
            newMealRef: Object,
            mealData: {
                name: null,
                subtitle: null,
                cookTime: {},
                prepTime: {},
                servings: null,
                recipeIndex: Number,
                mealType: null,
                mainImage: null,
            },
            meal: [],
            backgroundUrl: null,
            slug: null,
            userData: Object,
            file: null,
            mealType: [],
        }
    },

    async mounted() {
        
      await this.fetchData();
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.user_id = user.uid;
                db.collection('recipes').where('user_id', '==', user.uid).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                      if(!this.recipeIds.includes(doc.data().id, 0)) {
                          this.recipes.push(doc.data());
                      }

                    })
                });
                db.collection('recipeLikeables').where('user_id', '==', user.uid).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        var likeRecipeRef = db.collection('recipes').doc(doc.data().recipe_id);
                        likeRecipeRef.get().then(snapshot => {
                            if (!snapshot.exists) return;
                            this.recipes.push(snapshot.data())  // 
                        });
                    })
                });
                this.newMealRef = db.collection('meals').doc();
                    db.collection('users').doc(firebase.auth().currentUser.uid)
                        .get().then(docSnapshot => {
                            if (!docSnapshot.exists) return;
                            this.userData = docSnapshot.data();
                        });
                
                this.getCategories();
            } else {
                // User not logged in or has just logged out.
            }
        });
        
    },
    computed:{
        filteredRecipes(){
            // If there is no filter text, just return everyone
            if (!this.filterText) return this.recipes
            
            // Convert the search text to lower case
            let searchText = this.filterText.toLowerCase()
            
            // Use the standard javascript filter method of arrays
            // to return only people whose first name or last name
            // includes the search text
            return this.recipes.filter(p => {
                // if IE support is required and not pre-compiling,
                // use indexOf instead of includes
                return p.name.toLowerCase().includes(searchText)
            })
        }    
    },
    methods: {
        addToMeal(index) {
            this.mealData.recipes.push(this.recipes[index]);
            let cookMinutes = 0;
            let prepMinutes = 0;
            let lowest = Number.POSITIVE_INFINITY;
            let highest = Number.NEGATIVE_INFINITY;
            let servings;

            for (var i = 0; i < this.mealData.recipes.length; i++) {
                cookMinutes += (parseInt(this.mealData.recipes[i].cookTime.minutes) + parseInt(this.mealData.recipes[i].cookTime.hours * 60));
                prepMinutes += (parseInt(this.mealData.recipes[i].prepTime.minutes) + parseInt(this.mealData.recipes[i].prepTime.hours * 60));
                servings = this.mealData.recipes[i].servings;
                if (servings < lowest) {
                    lowest = servings;
                }
                if (servings > highest) {
                    highest = servings;
                }
            }
            this.mealData.cookTime.minutes = cookMinutes % 60;
            this.mealData.cookTime.hours = Math.floor(cookMinutes / 60);
            this.mealData.prepTime.minutes = prepMinutes % 60;
            this.mealData.prepTime.hours = Math.floor(prepMinutes / 60);
            this.mealData.servings = lowest;
            this.recipes.splice(index, 1);
        },
        saveMeal() {
            let slug = this.sanitizeTitle(this.mealData.name);
            // let uploadedImages = this.$refs.mainImage.getAcceptedFiles();
            

            const updated_at = new Date();
            db.collection("meals")
              .doc(this.id)
              .set({
                cookTime: {
                    hours: this.mealData.cookTime.hours,
                    minutes: this.mealData.cookTime.minutes
                },
                prepTime: {
                    hours: this.mealData.prepTime.hours,
                    minutes: this.mealData.prepTime.minutes
                },
                name: this.mealData.name,
                kitchen_name:this.userData.kitchen_name,
                slug: slug,
                subtitle: this.mealData.subtitle,
                mealType: this.mealData.mealType,
                mainImage: this.mealData.mainImage,
                recipes: this.mealData.recipes,
                updated_at:updated_at
              },{merge: true})
              .then(() => {
                this.success();

                let meal_id = this.mealData.id;  
                    db.collection('mealType').where(meal_id,'==',true)
                        .get().then(function(querySnapshot) {
                            querySnapshot.forEach(function(doc) {
                            doc.ref.update({[meal_id]:null});
                            });
                        });
                    db.collection("mealType").where("name", "==", this.mealData.mealType)
                        .get()
                        .then(function(querySnapshot) {
                            querySnapshot.forEach(function(doc) {
                                // console.log(doc.id, " => ", doc.data());
                                // Build doc ref from doc.id
                                db.collection("mealType").doc(doc.id).update({[meal_id]:true})
                            });
                        })
                        .catch(function(error) {
                            console.log("Error getting documents: ", error);
                        });
              });
        },
        removeFromMeal(index) {
            this.recipes.push(this.mealData.recipes[index])
            this.mealData.recipes.splice(index, 1);
            let cookMinutes = 0;
            let prepMinutes = 0;
            let lowest = Number.POSITIVE_INFINITY;
            let highest = Number.NEGATIVE_INFINITY;
            let servings;
            for (var i = 0; i < this.mealData.recipes.length; i++) {
                cookMinutes += (parseInt(this.mealData.recipes[i].cookTime.minutes) + parseInt(this.mealData.recipes[i].cookTime.hours * 60));
                prepMinutes += (parseInt(this.mealData.recipes[i].prepTime.minutes) + parseInt(this.mealData.recipes[i].prepTime.hours * 60));
                servings = this.mealData.recipes[i].servings;
                if (servings < lowest) {
                    lowest = servings;
                }
                if (servings > highest) {
                    highest = servings;
                }
            }
            this.mealData.cookTime.minutes = cookMinutes % 60;
            this.mealData.cookTime.hours = Math.floor(cookMinutes / 60);
            this.mealData.prepTime.minutes = prepMinutes % 60;
            this.mealData.prepTime.hours = Math.floor(prepMinutes / 60);
            this.mealData.servings = lowest;
        },
        fetchData() {
          db.collection("meals")
            .doc(this.id)
            .get()
            .then(docSnapshot => {
              if (!docSnapshot.exists) {
                this.$router.replace('/');
              } 
              if(docSnapshot.data().user_id == firebase.auth().currentUser.uid) {
                this.mealData = docSnapshot.data();
                this.subcategories = this.mealData.subcategories;
                for(let i=0;i<this.mealData.recipes.length;i++) {
                  this.recipeIds.push(this.mealData.recipes[i].id)
                }
                this.backgroundUrl = this.mealData.mainImage;
              }
              else {
                this.$router.replace('/kitchen/'+firebase.auth().currentUser.uid);
              }
            });
        },
        sanitizeTitle: function(title) {
            var slug = "";
            // Change to lower case
            var titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s+/g, '-');            
            return slug;
        },
        errorUpload(file, message) {
            console.log(message)
            this.$refs.mainImage.removeFile(file);
        },
        success() {
          this.$buefy.toast.open({
            message: "Recipe saved!",
            position: 'is-bottom',
            type: "is-success"
          });
        },
        deleteDropFile() {
            var imageName = this.mealData.mainImage;
        var imageToRemove = firebase.storage().ref(imageName);
        imageToRemove.delete().then(function() {
                // File deleted successfully
                // console.log(imageName + " File deleted successfully");
                
            }).catch(function(error) {
                console.log(error)
            });
            this.file = null;
            this.mealData.mainImage = null;        
      },
      onFileSelect(){
        const file = this.file[0];
        const self = this;
        if (typeof FileReader === 'function') {
            var reader = new FileReader();
            var imageName = uuidv4();
            reader.onloadend = function (evt) {
            var blob = new Blob([evt.target.result], { type: "image/jpeg" });
            firebase.storage().ref(imageName).put(blob)
            .then((snapshot) => {
                return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
            })
            .then((downloadURL) => {
                console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
                return self.setCurrentImage(imageName);
            })
            }
            reader.onerror = function (e) {
                console.log("Failed file read: " + e.toString());
            };
            reader.readAsArrayBuffer(file);
        } else {
            alert('Sorry, FileReader API not supported')
        }
        
      },
      setCurrentImage(downloadURL) {
              // console.log(downloadURL);
            this.mealData.mainImage =  downloadURL;
      },
      moveUp(index){
        let cutOut = this.mealData.recipes.splice(index, 1) [0]; // cut the element at index 'from'
        this.mealData.recipes.splice((index-1), 0, cutOut); 
      },
      moveDown(index){
        let cutOut = this.mealData.recipes.splice(index, 1) [0]; // cut the element at index 'from'
        this.mealData.recipes.splice((index+1), 0, cutOut); 
      },
      async getCategories() {
            // get the collection
            const mealType = db.collection('mealType')
            const { docs } = await mealType.get()
            // map all documents to the object
            docs.map(doc => {
                this.mealType.push(doc.data().name)
            })
      }
    }
};
</script>